import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';

@Component({
  selector: 'app-usermanual',
  templateUrl: './usermanual.component.html',
  styleUrls: ['./usermanual.component.css']
})
export class UsermanualComponent implements OnInit {

  RoleName: any = "";
  DocURL: any = "../../assets/User Manual/PaperSetter.pdf";
  constructor(private localstorage: LocalStorageService) { }

  ngOnInit() {
    this.RoleName = this.localstorage.get("UserRole");
    this.GetDocURL();
  }
  GetDocURL() {
    if (this.RoleName == "Super Admin") {
      this.DocURL = "../../assets/User Manual/SuperAdmin.pdf";
    }
    else if (this.RoleName == "Deputy Registrar Secrecy") {
      this.DocURL = "../../assets/User Manual/DRS.pdf"
    }
    else if (this.RoleName == "Paper Setter") {
      this.DocURL = "../../assets/User Manual/PaperSetter.pdf";
    }
    else if (this.RoleName == "Controller of Examination") {
      this.DocURL = "../../assets/User Manual/COE.pdf"
    }
    else if (this.RoleName == "Printer") {
      this.DocURL = "../../assets/User Manual/Printer.pdf"
    }
    else {
      this.DocURL = "";
    }
  }
}
